import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  Title,
  Mark,
  PicHolder,
  PicPivot
} from "./VisionariesSlide5.style"

import MarkIcon from "./mark.svg"

export default function VisionariesSlide5() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/textures/gallery/coronation_square/img-1d.jpg" />
          <Overlay>
            <Caption>
              <Title>
                Grant Associates – Planning <br />
                Landscape Architect
              </Title>
              <Text>
                Grant Associates are a pioneering international landscape
                architecture practice. Their work reconnects people with nature
                in insightful, delightful and distinctive ways whilst addressing
                the global challenges of urbanisation, the climate crisis and
                biodiversity extinction.
              </Text>
              <Text>
                The design process is underpinned by a knowledge of human
                behaviour, nature and ecological science combined with
                innovative design technology. They bring original thinking,
                creative collaboration and are exploring what regenerative
                design and the circular economy means to landscape architecture.
              </Text>
              <Text>
                While they enjoy being playful and inventive, their approach
                isn’t just about experience and aesthetics. It’s about the
                creation of inspirational places and spaces that have purpose, a
                distinctive identity, feel good to be in, promote wellbeing and
                are part of a healthy, biodiverse ecosystem.
              </Text>
              <Text>
                Grant Associates recognises the climate and biodiversity
                emergency as the defining challenge of our times. These two
                distinct issues, with considerable overlap, will be urgently
                addressed in all that we do. As landscape architects we will use
                our skills towards delivering a climate positive future and to
                protect and enhance biodiversity and the wonder of the natural
                world.
              </Text>
              <Mark src={MarkIcon}></Mark>
            </Caption>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
